<section class="login-area">
    <div class="row m-0">
        <div class="col-lg-6 col-md-12 p-0">
            <div class="login-image">
                <img
                    src="assets/img/ashkan-forouzani-ignxm3E1Rg4-unsplash.png"
                    alt="image"
                />
            </div>
        </div>

        <div class="col-lg-6 col-md-12 p-0">
            <div class="login-content">
                <div class="d-table">
                    <div class="d-table-cell">
                        <div class="login-form">
                            <div class="logo">
                                <a routerLink="/"
                                    ><img
                                        src="assets/img/black-logo.png"
                                        alt="image"
                                /></a>
                            </div>

                            <h3>{{ "Welcome Back" | translate }}</h3>
                            <p>
                                {{"New User?" | translate }}
                                <a routerLink="/register">{{"Sign up" | translate }}</a>
                            </p>

                            <form>
                                <div class="form-group mb-3">
                                    <input
                                        type="email"
                                        [placeholder]="'Email' | translate"
                                        class="form-control"
                                        name="txtEmail"
                                        [(ngModel)]="email"
                                    />
                                </div>

                                <div class="form-group mb-3">
                                    <input
                                        type="password"
                                        [placeholder]="'Password' | translate"
                                        class="form-control"
                                        name="txtPassword"
                                        [(ngModel)]="password"
                                    />
                                </div>

                                <button
                                    type="submit"
                                    [disabled]="!email || !password"
                                    (click)="login()"
                                >
                                    {{"Login" | translate }}
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
